import { z } from 'zod'

export const cartSchema = z.record(z.coerce.number(), z.number().optional())
